const SkeletonContactUsForm = () => {
  return (
    <div
      className="skeletonForm"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      {/* Row 1 - First Name and Last Name */}
      <div className="skeletonFormRow">
        <div className="skeleton-input"></div>

        <div className="skeleton-input"></div>
      </div>

      {/* Row 2 - Phone and Company Name */}
      <div className="skeletonFormRow">
        <div className="skeleton-input"></div>

        <div className="skeleton-input"></div>
      </div>

      {/* Row 3 - Email */}

      <div className="skeletonFormRow">
        <div className="skeleton-input" style={{ width: '100%' }}></div>
      </div>

      <div className="skeletonFormRow">
        <div className="skeleton-input"></div>

        <div className="skeleton-input"></div>
      </div>

      <div className="skeletonFormRow">
        <div className="skeleton-input" style={{ width: '100%' }}></div>
      </div>

      <div
        className="skeletonFormRow"
        style={{
          display: 'flex',
          alignItems: 'center',
          height: '48px',
          marginBottom: '16px',
          justifyContent: 'normal',
          marginTop: '-10px',
        }}
      >
        <div
          className="skeleton-checkbox"
          style={{
            width: '24px',
            height: '24px',
            borderRadius: '50%',
            marginRight: '12px',
            marginBottom: '0px',
          }}
        />
        <div className="skeletonBox">
          <div
            className="skeleton-text"
            style={{
              width: '100%',
              height: '18px',
              marginBottom: '0px !important',
            }}
          />
          <div
            className="skeleton-text secondText"
            style={{
              width: '100%',
              height: '18px',
              marginBottom: '0px !important',
              maxWidth: '300px',
            }}
          />
        </div>
      </div>
      <div className="skeletonBox secondBox">
        <div
          className="skeleton-text"
          style={{
            width: '100%',
            height: '18px',
            marginBottom: '0px !important',
          }}
        />
        <div
          className="skeleton-text"
          style={{
            width: '100%',
            height: '18px',
            marginBottom: '16px !important',
            maxWidth: '300px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        />
      </div>

      <div className="skeletonBox recatpchaBox">
        <div
          className="skeleton-text"
          style={{
            width: '100%',
            height: '18px',
            maxWidth: '300px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        />
      </div>
      <div className="skeleton-button"></div>
    </div>
  );
};

export default SkeletonContactUsForm;
